﻿export enum TipoRolSiuEnum {
  EXTERNO = 1,
  INTERNO = 2
}

export enum OficinaEnum {
  SUNEDU = 'SUNEDU', // 	SUPERINTENDENCIA NACIONAL DE EDUCACIÓN SUPERIOR UNIVERSITARIA
  CD = 'CD', // 	CONSEJO DIRECTIVO
  SUPERINTENDENCIA = 'SUPERINTENDENCIA', // 	SUPERINTENDENCIA
  SG = 'SG', // 	SECRETARÍA GENERAL
  PP = 'PP', // 	PROCURADURÍA PÚBLICA
  DILIC = 'DILIC', // 	DIRECCIÓN DE LICENCIAMIENTO
  DISUP = 'DISUP', // 	DIRECCIÓN DE SUPERVISIÓN
  DIFISA = 'DIFISA', // 	DIRECCIÓN DE FISCALIZACIÓN Y SANCIÓN
  DIGRAT = 'DIGRAT', // 	DIRECCIÓN DE DOCUMENTACIÓN E INFORMACIÓN UNIVERSITARIA Y REGISTRO DE GRADOS Y TÍTULOS
  OAJ = 'OAJ', // 	OFICINA DE ASESORÍA JURÍDICA
  OPP = 'OPP', // 	OFICINA DE PLANEAMIENTO Y PRESUPUESTO
  OA = 'OA', // 	OFICINA DE ADMINISTRACIÓN
  OTI = 'OTI', // 	OFICINA DE TECNOLOGÍAS DE LA INFORMACIÓN
  RRHH = 'RRHH', // 	OFICINA DE RECURSOS HUMANOS
  OCOM = 'OCOM', // 	OFICINA DE COMUNICACIONES
  UDIU = 'UDIU', // 	UNIDAD DE DOCUMENTACIÓN E INFORMACION UNIVERSITARIA
  URGT = 'URGT', // 	UNIDAD DE REGISTRO DE GRADOS Y TITULOS
  OD = 'OD', // 	ÓRGANOS DESCONCENTRADOS
  OCI = 'OCI', // 	ÓRGANO DE CONTROL INSTITUCIONAL
  UA = 'UA', // 	UNIDAD DE ABASTECIMIENTO
  UAF = 'UAF', // 	UNIDAD DE ADMINISTRACIÓN FINANCIERA
  UEC = 'UEC', // 	UNIDAD DE EJECUCIÓN COACTIVA
  UACTD = 'UACTD', // 	UNIDAD DE ATENCIÓN AL CIUDADANO Y TRÁMITE DOCUMENTARIO
  UPEM = 'UPEM', // 	UNIDAD DE PLANEAMIENTO ESTRATÉGICO Y MODERNIZACIÓN
  UP = 'UP' // 	UNIDAD DE PRESUPUESTO
}
